///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GtthStepsToolbarModule } from './steps-toolbar/step-toolbar.module';
import { GtthProjectWindowsModule } from './project-windows/project-windows.module';

import { GtthSharedModule } from '../shared/shared.module';
import { projectViewRoute } from './project-view.route';
import { GtthProjectViewComponent } from './project-view.component';
import { ActionsToolbarComponent } from './actions-toolbar/actions-toolbar.component';
import { GtthLinkInfoComponent } from './logical-topology/map-entities-info/link-info/link-info.component';
import { GtthProjectSettingsComponent } from './project-settings-panel/project-settings.component';
import { GtthGlobalActionToolbarComponent } from './global-actions-toolbar/global-actions-toolbar.component';
import { GtthAlertsContainerComponent } from './alerts-container/alerts-container.component';
import { MatDialog, MatDialogClose } from '@angular/material/dialog';
import { LosInfoPanelComponent } from './logical-topology/map-entities-info/link-info/los-panel/los-info-panel.component';
import { SuiProjectEditableSelectComponent } from '../shared/sui-lib-customisations/sui-select/editable/project/sui-project-editable-select.component';
import { LinkInfoPanelComponent } from './logical-topology/map-entities-info/link-info/link-panel/link-info-panel.component';
import { TabsNavComponent } from '../shared/tabs-nav/tabs-nav.component';
import { ContextSensitiveHelpComponent } from '../shared/context-sensitive-help/ctx-sensitive-help.component';
import {
    SuiSelectControlComponent,
    SuiSelectEnumControlComponent,
    SuiSvgIconComponent,
    SuiTooltipDirective,
    SuiTranslateEnumPipe,
    SuiTranslatePipe
} from '@siklu/sui-lib';
import { GtthUnitConfigComponent } from './logical-topology/map-entities-config/unit-config.component';

const ENTITY_STATES = [...projectViewRoute];

@NgModule({
    imports: [
        GtthSharedModule,
        GtthStepsToolbarModule,
        GtthProjectWindowsModule,
        RouterModule.forChild(ENTITY_STATES),
        MatDialogClose,
        SuiProjectEditableSelectComponent,
        LosInfoPanelComponent,
        LinkInfoPanelComponent,
        TabsNavComponent,
        ContextSensitiveHelpComponent,
        SuiSvgIconComponent,
        SuiTranslatePipe,
        SuiTooltipDirective,
        SuiTranslateEnumPipe,
        SuiSelectEnumControlComponent,
        SuiSelectControlComponent,
        ActionsToolbarComponent,
        GtthUnitConfigComponent
    ],
    declarations: [
        GtthProjectViewComponent,
        GtthLinkInfoComponent,
        GtthProjectSettingsComponent,
        GtthGlobalActionToolbarComponent,
        GtthAlertsContainerComponent
    ],
    providers: [MatDialog],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GtthProjectViewModule {}
